var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',{staticClass:"text-center",attrs:{"cols":"12"}},[_c('p',[_vm._v("Diese Seite konnte nicht gefunden werden.")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }